<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaReportDialog',
})
</script>
<template>
	<ma-data-table
		:key="visible + ''"
		v-model:visible="visible"
		row-key="id"
		:title="t('componentsModule.maReport.title')"
		url="/maku/biz_inspect_device_report/page"
		method="post"
		:multiple
		:default-selected="defaultSelected"
		:columns="[
			{ field: 'fileName', label: t('componentsModule.maReport.fileName') },
			{ field: 'deviceName', label: t('componentsModule.maReport.deviceName') },
			{ field: 'createTime', label: t('componentsModule.maReport.createTime') }
		]"
		:query-params="[{ field: 'fileName', label: t('componentsModule.maReport.fileName'), type: 'input' }]"
		:query-form="{ type: 2 }"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="MaReportDialog">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: true
	},
	defaultSelected: {
		type: Array,
		required: false,
		default: () => []
	}
})

const visible = defineModel<boolean>()

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	emit('select', rows)
}
</script>
